import React from "react";
import Confirmed from "./Confirmed/Confirmed";
import { NewTab, PageTab } from "../../../components";
import { useModuleAccess } from "../../../hooks";

const ConfirmedOrStart = () => {
  const confirmedMenus = [
    {
      title: "Confirmed / Starts",
      page: <Confirmed />,
      type: "main",
      id: "confirmedstarts_confirmedstarts",
    },
  ];
  const filteredTabs = useModuleAccess({
    allTabs: confirmedMenus,
    parentId: "confirmedstarts",
  });
  return (
    <NewTab
      tabs={filteredTabs}
      color="black"
      variant="outlined"
      mode="url"
      tabId="confirmed-starts"
    />
  );
};

export default ConfirmedOrStart;
